const carBreakRule = () => import('@/pages/carBreakRule/index')
const carBreakRuledetail = () => import('@/pages/carBreakRule/detail')

export default [
  {
    path: '/carBreakRule',
    name: '/carBreakRule',
    component: carBreakRule,
    meta: {
      // storeKey: 'trs.mtc.ticket'
    }
  },
  {
    path: '/carBreakRuledetail',
    name: '/carBreakRuledetail',
    component: carBreakRuledetail,
    meta: {
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/carBreakRule/index.js